export default "__VITE_ASSET__Ci3Li7OH__"